import React from 'react';
import { NavLink, Outlet } from 'react-router';
import { LscAuthGate } from '../hooks/useLscAuthGate';
import { lscPath, lscReturnTo } from '../routing';
import {
  LSC_ADMIN_NO_MUTATION_NOTE,
  LSC_ADMIN_SHELL_INTRO,
  LSC_ADMIN_SHELL_TITLE,
} from '../adminIssueCopy';
import LscAdminAccessGate from '../components/admin/LscAdminAccessGate';

function adminNavClass({ isActive }: { isActive: boolean }): string {
  return [
    'rounded-lg px-3 py-2 text-sm transition-colors',
    isActive
      ? 'bg-primary-900/50 text-primary-200 border border-primary-700'
      : 'text-secondary-300 hover:bg-secondary-800 hover:text-white border border-transparent',
  ].join(' ');
}

function LscAdminLayoutContent() {
  return (
    <LscAdminAccessGate>
      <div className="space-y-6" data-testid="lsc-admin-layout">
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-wide text-amber-300/90">Internal · Admin only</p>
          <h1 className="text-2xl font-bold text-white">{LSC_ADMIN_SHELL_TITLE}</h1>
          <p className="text-sm text-secondary-400">{LSC_ADMIN_SHELL_INTRO}</p>
          <p className="text-xs text-secondary-500">{LSC_ADMIN_NO_MUTATION_NOTE}</p>
        </div>

        <nav
          className="flex flex-wrap gap-2"
          aria-label="LSC admin navigation"
          data-testid="lsc-admin-nav"
        >
          <NavLink to={lscPath('/admin')} end className={adminNavClass} data-testid="lsc-admin-nav-home">
            Overview
          </NavLink>
          <NavLink
            to={lscPath('/admin/issues')}
            className={adminNavClass}
            data-testid="lsc-admin-nav-issues"
          >
            Support issues
          </NavLink>
        </nav>

        <Outlet />
      </div>
    </LscAdminAccessGate>
  );
}

const LscAdminLayout: React.FC = () => (
  <LscAuthGate returnTo={lscReturnTo('/admin')}>
    <LscAdminLayoutContent />
  </LscAuthGate>
);

export default LscAdminLayout;
